module.exports = __webpack_public_path__ + "img/spin-black.92242138.svg";